import './ChartTitleInput.scss';

import React, { useEffect, useState } from 'react';
import { FlightTextInput } from '@flybits/design-system';
import { ChartConfigState } from 'pages/AnalyticsV2/types';

const MAIN_CLASS = 'chart-title-selector';
interface ChartTitleInputProps {
  chartConfig: ChartConfigState;
  errorMessage?: string;
  onChange: (title: string) => void;
  onValidation: (isValid: boolean) => void;
  placeholderText?: string;
  className?: string;
  /** Wider field and label styling for Create/Edit chart page header. */
  variant?: 'default' | 'pageHeader';
}

export default function ChartTitleInput({
  chartConfig,
  errorMessage,
  onChange,
  onValidation,
  placeholderText = 'Untitled',
  className,
  variant = 'default',
}: ChartTitleInputProps) {
  const { title = '' } = chartConfig;
  const [validationError, setValidationError] = useState<string | undefined>(undefined);

  useEffect(() => {
    let error: string | undefined = undefined;
    let isValid = true;
    const trimmedTitle = title.trim();

    if (trimmedTitle === '') {
      isValid = false;
      error = 'Title cannot be empty';
    } else if (trimmedTitle.length >= 35) {
      isValid = false;
      error = 'Title must be less than 35 characters';
    } else if (!/^[a-zA-Z0-9\s-]*$/.test(trimmedTitle || '')) {
      isValid = false;
      error = 'Title can only contain alphanumeric characters, space and hyphen (-)';
    }

    setValidationError(error);
    onValidation(isValid);
  }, [title, onValidation]);

  const sectionClass = [MAIN_CLASS, variant === 'pageHeader' && `${MAIN_CLASS}--page-header`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <section className={sectionClass}>
      <FlightTextInput
        value={title || ''}
        width={'100%'}
        placeholderText={placeholderText}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value || '')}
        hasError={!!validationError || !!errorMessage}
        errorMessage={validationError || errorMessage}
        ariaLabel={'Title your chart'}
        isAriaRequired={variant === 'pageHeader'}
      />
    </section>
  );
}
